export default "__VITE_ASSET__BAmTJwKw__"